<div class="component-main-container ion-padding-horizontal" *ngIf="leadDetails">

  <ion-toolbar class="component-header">
    <div class="header-container" *ngIf="leadDetails">
      <div class="start">
        <span class="clickable-text" (click)="navigatePrev()"><ion-icon name="arrow-back-outline"></ion-icon></span>
        <ion-text class="ion-margin-start text-capitalize">{{leadDetails.firstName}} {{leadDetails.lastName}}
          ({{leadDetails.leadId}})</ion-text>
      </div>
      <ng-container>
        <div class="end">
          <div class="options">
            <ion-text (click)="scrollTo('detailsSection')">Details</ion-text>
            <ion-text (click)="scrollTo('vouchersSection')" *ngIf="showVouchers">Voucher</ion-text>
            <ion-text (click)="scrollTo('InvoiceSection')" *ngIf="showInvoiceSection">Invoice</ion-text>
            <ion-text (click)="scrollTo('quotesSection')">Quote</ion-text>
            <ion-text (click)="scrollTo('passengersSection')">Passengers</ion-text>
            <ion-text (click)="scrollTo('tasksSection')" *ngIf="hideTaskView">Tasks</ion-text>
            <ion-text (click)="scrollTo('emailsSection')">Email</ion-text>
          </div>
          <ion-button fill="clear" color="dark" [ngStyle]="{ 'display': hideCompleteOptions ? 'none' : 'block' }"
            (click)="openPersonOptionsPopover($event)"><ion-icon
              name="ellipsis-horizontal-outline"></ion-icon></ion-button>
        </div>
      </ng-container>
    </div>
  </ion-toolbar>

  <div class="component-body">
    <ion-grid>
      <ion-row class="mt-2 justify-content-between" id="detailsSection">
        <ion-col size="6.6" [size]="quoteDetails? '6.6': '12'" class="view-details">
          <div class="">
            <div class="d-flex justify-content-between">
              <h6>Lead Details</h6>
              <ion-button [ngStyle]="{ 'display': showEditButton ? 'block' : 'none' }" fill="clear" size="small"
                (click)="openEditLeadForm()"><ion-icon name="create-outline"></ion-icon></ion-button>
            </div>

            <div class="row">
              <div class="col-7 info">
                <div class="info-item">
                  <p class="label">Full Name</p>
                  <p class="value">{{leadDetails.firstName}} {{leadDetails.lastName}}</p>
                </div>
                <div class="info-item">
                  <p class="label">Email Address</p>
                  <p class="value text-break">{{leadDetails.email}}<span *ngIf="!leadDetails.email">--</span></p>
                </div>
                <div class="info-item">
                  <p class="label">Assigned Owner</p>
                  <p class="value">{{leadDetails.ownershipName}}<span *ngIf="!leadDetails.ownership">--</span></p>
                </div>
                <div class="info-item">
                  <p class="label">Status</p>
                  <p class="value">{{leadDetails.status}}<span *ngIf="!leadDetails.status">--</span></p>
                </div>
                <div class="info-item">
                  <p class="label">Created By</p>
                  <p class="value">{{leadDetails.createdBy}}<span *ngIf="!leadDetails.createdBy">--</span></p>
                </div>
                <div class="info-item">
                  <p class="label">Travel Service</p>
                  <ng-container *ngIf="leadDetails.travelServices.includes('Tour Package'); else notPackage">
                    <p class="value">Tour Package</p>
                  </ng-container>
                  <ng-template #notPackage>
                    <p class="value">{{leadDetails.travelServices.join(', ')}}<span
                        *ngIf="!leadDetails.travelServices">--</span></p>
                  </ng-template>
                </div>
              </div>

              <div class="col-5 info">
                <div class="info-item-sm">
                  <p class="label">Client ID</p>
                  <p class="value clickable-text" routerLink="/clients/details/{{leadDetails.clientId}}">
                    {{leadDetails.clientId}}</p>
                </div>
                <div class="info-item-sm">
                  <p class="label">Phone</p>
                  <p class="value">{{leadDetails.phoneNumber.countryCode}} {{leadDetails.phoneNumber.phone}}</p>
                </div>
                <div class="info-item-sm">
                  <p class="label">Alt Phone</p>
                  <p class="value"><span
                      *ngIf="leadDetails.alternativePhoneNumber?.phone">{{leadDetails.alternativePhoneNumber?.countryCode}}
                      {{leadDetails.alternativePhoneNumber?.phone}}</span> <span
                      *ngIf="!leadDetails.alternativePhoneNumber?.phone">--</span></p>
                </div>
                <div class="info-item-sm">
                  <p class="label">Source</p>
                  <p class="value">{{leadDetails.source}}<span *ngIf="!leadDetails.source">--</span></p>
                </div>
                <div class="info-item-sm">
                  <p class="label">Priority</p>
                  <p class="value">{{leadDetails.priority}}<span *ngIf="!leadDetails.priority">--</span></p>
                </div>
                <div class="info-item-sm">
                  <p class="label">Date</p>
                  <p class="value">{{leadDetails.createDate | date : 'MMM d, yyyy - h:mm a'}}<span
                      *ngIf="!leadDetails.createDate">--</span></p>
                </div>
              </div>

              <div class="col-12 info">

              </div>
            </div>
          </div>
        </ion-col>
        <ion-col size="5.3" class="view-details" *ngIf="quoteDetails">
          <div class="">
            <h6>Travel Preference ({{quoteDetails.itineraryId}})</h6>
            <div class="row">
              <div class="col-12 info">
                <div class="info-item">
                  <p class="label">Itinerary Name</p>
                  <p class="value text-capitalize">{{quoteDetails.itineraryName}}</p>
                </div>
                <div class="info-item">
                  <p class="label">Destinations</p>
                  <p class="value text-capitalize" style="word-break: unset;"><span
                      *ngFor="let dest of quoteDetails.destination; index as i">{{dest.location}}<span
                        *ngIf="i+1 !== quoteDetails.destination.length"> | </span></span></p>
                </div>
                <div class="info-item">
                  <p class="label">Start Date</p>
                  <p class="value text-capitalize">{{quoteDetails.startDate | date}}</p>
                </div>
                <div class="info-item">
                  <p class="label">End Date</p>
                  <p class="value text-capitalize">{{quoteDetails.endDate | date}}</p>
                </div>
                <div class="info-item">
                  <p class="label">No Of Guest</p>
                  <p class="value text-capitalize">{{quoteDetails.totalAdults}} Adults | {{quoteDetails.totalChildrens}}
                    Children</p>
                </div>
              </div>


            </div>
          </div>
        </ion-col>
      </ion-row>

      <!-- Lead Notes -->
      <ion-row class="itinerary-row" *ngIf="leadDetails">
        <ion-col>
          <ion-row size="12">
            <div class="lead-notes-inner-row row">
              <div class="col-6">
                <h6>Notes</h6>
                <div class="w-100 h-100">
                  <div class="input-container h-100">
                    <div class="d-flex flex-column">
                      <textarea name="" class="input lead-notes-textarea" id=""
                        placeholder="Write Lead Related Notes here." #newLeadNote></textarea>
                      <div class="d-flex justify-content-end">
                        <ion-button [ngStyle]="{ 'display': showEditButton ? 'block' : 'none' }" class="filled-blue-btn"
                          (click)="saveLeadNotes($event)">Save</ion-button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6 pe-0">
                <h6>Previous Notes</h6>
                <div class="w-100 notes-history-container"
                  *ngIf="leadDetails.leadNotes && leadDetails.leadNotes.length">
                  <div class="item" *ngFor="let note of leadDetails.leadNotes.slice().reverse(); index as i">
                    <div class="d-flex justify-content-between">
                      <p class="text title">{{note.userName}}</p>
                      <p class="text title">{{note.createDate | date : 'MMM d, yyyy - h:mm a'}}</p>
                    </div>
                    <div>
                      <p class="text" [innerHTML]="replaceLineBreakWithbreakTag(note.note)"></p>
                      <ion-button class="delete-btn" size="small" fill="clear" color="danger"
                        (click)="deleteLeadNotesItem(i)"><ion-icon name="trash-outline"></ion-icon></ion-button>
                    </div>
                  </div>
                </div>
                <div class="w-100 notes-history-container"
                  *ngIf="leadDetails.leadNotes === null || leadDetails.leadNotes.length === 0">
                  <div class="item">
                    <p class="text fw-bold border-0">No Notes Added</p>
                  </div>
                </div>
              </div>
            </div>

          </ion-row>
        </ion-col>
      </ion-row>
      <ng-container>
        <!-- Confirm voucher and quote -->
        <ion-row class="itinerary-row" *ngIf="showVouchers && !leadForVisa" id="vouchersSection">
          <ion-col>
            <h6>Voucher</h6>
            <ion-row size="12">
              <div class="w-100">
                <app-grid-view [allData]="clientVouchers" [columns]="clinentVouchersColumsn"
                  [showColumnSelector]="false" (triggerDeleteRow)="deleteVoucher($event)"
                  (triggerEditRow)="editVoucher($event)" (triggerViewRow)="viewVoucher($event)"
                  [optionsValues]="vouchersOptionsValues"
                  (emitRowOnCellClicked)="voucherCellClicked($event)"></app-grid-view>
              </div>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Leads quotes -->
        <ion-row class="itinerary-row" *ngIf="!leadForVisa" id="quotesSection">
          <ion-col>
            <h6>Quote & Versions</h6>
            <ion-row size="12">
              <div class="w-100">
                <app-quotes-grid-view [allData]="allLeadItinerarys" [columns]="allLeadItineraryColumns"
                  (paginationsUpdated)="getAllQuotesForLead($event)" (emitTableOptionClicked)="onOptionSelected($event)"
                  (emitRowOnCellClicked)="onTableCellClicked($event)"></app-quotes-grid-view>
              </div>
            </ion-row>
            <ion-row>
              <ion-button [ngStyle]="{ 'display': showQuoteButton ? 'block' : 'none' }"
                (click)="openQuoteItineraryForm()" class="unfilled-blue-btn" *ngIf="showCreateQuoteButton">
                Create Quote
              </ion-button>
              <!-- <ion-button class="filled-blue-btn">
              Send Mail
            </ion-button> -->
            </ion-row>
          </ion-col>
        </ion-row>

        <ng-container *ngIf="showInvoiceSection">
          <app-invoice-payments [leadId]="leadIdUrl"></app-invoice-payments>
        </ng-container>

        <!-- visa passenger list -->

        <ion-row class="itinerary-row" *ngIf="leadForVisa && allVisasOfLead" id="quotesSection">
          <ion-col>
            <h6>Visa</h6>
            <ion-row size="12">
              <div class="w-100">
                <app-visa-passenger-grid [allData]="allVisasOfLead"
                  [columns]="allVisaOfLeadColumns"></app-visa-passenger-grid>
              </div>
            </ion-row>
            <ion-row>
              <ion-button class="unfilled-blue-btn" (click)="openVisaModal()">
                Visa
              </ion-button>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Leads guests -->

        <app-passengers-list [leadId]="leadIdUrl"></app-passengers-list>

        <!-- Leads Of client -->
        <ion-row class="itinerary-row">
          <ion-col>
            <div class="d-flex justify-content-between align-items-center">
              <h6>Related Leads</h6>
              <!-- <div>
            <ion-button class="filled-blue-btn" (click)="addLeadForClient(clientIdUrl)"><ion-icon name="add-outline"></ion-icon> Add Lead</ion-button>
          </div> -->
            </div>

            <ion-row size="12">
              <div class="w-100" *ngIf="allLeadsOfClient">
                <app-grid-view [allData]="allLeadsOfClient" [columns]="leadsOfClientColumns" [showColumnSelector]="true"
                  [optionsValues]="false" (emitRowOnCellClicked)="leadsOfClientEmittedRowClicked($event)"
                  (paginationsUpdated)="getDefaultLeadsOfClinet(leadDetails?.clientId ,$event)"></app-grid-view>
              </div>
            </ion-row>
          </ion-col>
        </ion-row>

        <!-- Lead's tasks -->
        <ion-row class="itinerary-row" id="tasksSection" *ngIf="hideTaskView">
          <ion-col>
            <h6>Tasks</h6>
            <ion-row size="12">
              <div class="w-100">
                <app-grid-view [allData]="allLeadTasks" [columns]="leadTaskColumns" [showColumnSelector]="false"
                  [optionsValues]="tasksOptionsValues" (triggerDeleteRow)="deleteTask($event)"
                  (triggerEditRow)="editTask($event)" (triggerViewRow)="viewTask($event)" [showStatusDropdown]="true"
                  (triggerStatusChange)="taskStatusChanged($event)"></app-grid-view>
              </div>
            </ion-row>
            <ion-row>
              <ion-button *ngIf="hideCreateTask" (click)="createTaskForLead()" class="unfilled-blue-btn">
                Create Task
              </ion-button>
            </ion-row>

          </ion-col>

        </ion-row>

        <ion-row class="itinerary-row" *ngIf="false">
          <ion-col>
            <h6>Tasks</h6>
            <ion-row size="12">
              <div class="w-100">
                <app-draggable-board [leadId]="leadIdUrl"></app-draggable-board>
              </div>
            </ion-row>
          </ion-col>

        </ion-row>

        <!-- calls of lead -->
        <ion-row class="itinerary-row">
          <ion-col>
            <div class="d-flex justify-content-between align-items-center">
              <h6>Calls Related To Lead</h6>
            </div>

            <ion-row size="12">
              <div class="w-100" *ngIf="allCallsOfLead">
                <app-grid-view [allData]="allCallsOfLead" [columns]="callsOfLeadsColumns" [showColumnSelector]="true"
                  [optionsValues]="false" (paginationsUpdated)="getCallsOfLead($event)"></app-grid-view>
              </div>
            </ion-row>
          </ion-col>
        </ion-row>

        <ion-row class="itinerary-row" id="emailsSection">
          <ion-col>
            <div class="d-flex justify-content-between align-items-center">
              <h6>Email History</h6>
            </div>

            <ion-row size="12">
              <div class="w-100" *ngIf="allDmcVendorsEmails">
                <app-grid-view [allData]="allDmcVendorsEmails" [columns]="VendorDmcColumns" [showColumnSelector]="true"
                  (emitRowOnCellClicked)="ViewVendorDmcEmail($event)" (paginationsUpdated)="VendorDmcsemails($event)"
                  [hidePaginationHard]="true"></app-grid-view>
              </div>
            </ion-row>
          </ion-col>
        </ion-row>
      </ng-container>
    </ion-grid>
  </div>

</div>